export const StatusTypes = {
    VoluntaryWaitingPeriod: 'Voluntary Waiting Period',
    ReproPeriod: 'Repro Period',
    Inseminated: 'Inseminated',
    Pregnant: 'Pregnant',
    Dry: 'Dry',
    Cull: 'Cull',
    // Local client types
    States: 'States',
}


// WEBPACK FOOTER //
// ./src/constants/status_types.js